import React from 'react';
import { Tag, Tooltip } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { websiteConfirmation, websiteContactMismatch, websiteConfirmationTooltip } from '../../models/shared/websiteConfirmationModel';

const chipStyle = { margin: 0, fontSize: 11, lineHeight: '18px' };
export function WebsiteConfirmationChip({ query }) {
  const state = websiteConfirmation(query?.website_confirmation, query?.website_confirmation_at);
  const mismatch = websiteContactMismatch(query);
  const website = query?.query_source === 'website';
  if (!state && !mismatch && !website) return null;
  return <>
    {!state && website && <Tag icon={<GlobalOutlined />} style={chipStyle}>Website</Tag>}
    {state && <Tooltip title={websiteConfirmationTooltip(query)}><Tag icon={website ? <GlobalOutlined /> : undefined} color={state.color} style={chipStyle}>{state.label}</Tag></Tooltip>}
    {mismatch && <Tooltip title={mismatch.tooltip}><Tag color="warning" style={chipStyle}>{mismatch.label}</Tag></Tooltip>}
  </>;
}
